export const URLS = {
    FAQS: "https://support.scorza.com/hc/",
    FEEDBACK: "https://feedback.scorza.com/sso/",
    TERMSCONDITIONS: "https://scorza.com/terms-conditions",
    PRIVACYPOLICY: "https://assets.scorza.com/policies/privacy-policy.html",
    REFSIX_ACCOUNT: "https://app.scorza.com/",
    MGM_TERMS: "https://scorza.com/referral-ts-and-cs",
    SCORZA_HOME: "https://www.scorza.com",
};

export const SUPPORT_EMAIL = "support@scorza.com";

export interface VimeoVideo {
    id: string;
    // Required for unlisted videos - the "h" query parameter of the embed url.
    hash?: string;
}

export const VIMEO_VIDEOS: { [key: string]: VimeoVideo } = {
    PLAYING_PERIODS_TUTORIAL: { id: "1215469562", hash: "0a86af8dc8" },
};

export const getScorzaHomeUrlWithTracking = () => {
    const params = new URLSearchParams({
        utm_source: "scorza-app",
        utm_medium: "app",
        utm_campaign: "auth_i_dont_have_scorza",
    });

    return `${URLS.SCORZA_HOME}?${params.toString()}`;
};
